import React, { useState } from 'react';
import CardWrapper from '../cardWrapper';
import './decisionConfirmation.scss';
import { Box, Grid } from '@mui/material';
import {
  KFButton,
  KFTextInput,
  withTranslation,
  WithTranslation,
} from '@kf/ic2fx';
import { colors } from 'styles/colors';
import { IMakeDecisionData } from '.';
import {
  HMDecisionModalActions,
  THMDecisionModalActions,
  shouldAdvance,
} from 'modules/hiring/models/hiringDecisionOption';
import CheckIcon from '@mui/icons-material/Check';
import TypographyWithI18N from 'shared/components/TypographyWithI18N';
import { HiringActivity } from 'modules/hiring/models/candidatePipeline.model';
export interface IDecisionConfirmation extends WithTranslation {
  success: (note?: string) => void;
  cancel: () => void;
  data: IMakeDecisionData | null;
  activeDecision?: THMDecisionModalActions;
  showSuccessPopup?: boolean;
  defaultNote?: string;
}

const DecisionConfirmation = ({
  success,
  cancel,
  activeDecision,
  data,
  showSuccessPopup,
  defaultNote = '',
  t: translate,
}: IDecisionConfirmation) => {
  const [note, setNote] = useState<string>(defaultNote);
  const isDecisionMatch = activeDecision === HMDecisionModalActions.Offer;
  const isAdvanced = activeDecision === HMDecisionModalActions.Advance;
  return (
    <CardWrapper
      id='confirmation-card-wrapper'
      className={`decisionWrapperHeader 
    ${
      isDecisionMatch || isAdvanced
        ? 'offer-shape'
        : shouldAdvance(data?.activityName as HiringActivity)
        ? 'advance-shape'
        : 'pass-shape'
    }`}
      sx={{ minHeight: 'auto' }}
    >
      {!showSuccessPopup ? (
        <Box>
          {isAdvanced ? (
            <TypographyWithI18N
              className='kfic2-bodyText'
              data-testid='confirmation-advance-info'
              id='confirmation-advance-info'
              sx={{ fontWeight: 700 }}
              i18nKey={translate(
                'addNotesAndConfirmThatYouLikeToAdvanceSomeToHiringManagerInterviewStage',
                { arg1: data?.name, interpolation: { escapeValue: false } }
              )}
            />
          ) : (
            <TypographyWithI18N
              className='kfic2-bodyText'
              data-testid='confirmation-info'
              id='confirmation-info'
              sx={{ fontWeight: 700 }}
              i18nKey={translate(
                activeDecision === 'Offer'
                  ? 'addNotesAndConfirmThatYoudLikeToSendSomeAnOfferForSomeSome'
                  : 'addNotesAndConfirmThatYoudLikeToPassOnSomeForSomeSome',
                {
                  arg1: data?.name,
                  arg2: data?.jobTitle,
                  arg3: data?.requisitionId,
                  interpolation: { escapeValue: false },
                }
              )}
            />
          )}

          <Box sx={{ py: '1.25rem' }}>
            <KFTextInput
              id='confirmation-box-text-input'
              data-testid='confirmation-box-text-input'
              maxRows={5}
              minRows={5}
              multiline
              placeholder={translate('addNotesHere') + '....'}
              rows={5}
              value={note}
              onChange={(e) => setNote(e?.target?.value)}
              inputProps={{
                maxLength: 5000,
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
            <KFButton
              data-testid='cancel-modal-button'
              sx={{
                height: '2.375rem',
                width: '5.063rem',
                '&.Mui-disabled': {
                  color: colors.tertiary.darkGray,
                },
              }}
              disabled={false}
              color='quaternary'
              onClick={cancel}
            >
              {translate('cancel')}
            </KFButton>
            <KFButton
              data-testid='confirm-modal-button'
              sx={{
                height: '2.375rem',
                '&.Mui-disabled': {
                  color: `${colors.tertiary.darkGray} !important`,
                },
                ml: '1.25rem !important',
              }}
              disabled={!note?.trim()}
              color={isDecisionMatch || isAdvanced ? 'primary' : 'danger'}
              onClick={() => success(note)}
            >
              {translate(
                isAdvanced
                  ? 'confirmAndAdvance'
                  : isDecisionMatch
                  ? 'confirmAndSendOffer'
                  : 'confirmAndPassOnCandidate'
              )}
            </KFButton>
          </Box>
        </Box>
      ) : (
        <Grid sx={{ height: '84px', textAlign: 'center' }}>
          <Grid data-testid='success-confirmation'>
            <CheckIcon
              sx={{
                color: colors.primary,
                border: `0.063rem solid ${colors.primary}`,
                borderRadius: '1.125rem',
                fontSize: '2.25rem',
                padding: '0.313rem',
              }}
            />
          </Grid>
          <TypographyWithI18N
            className='kfic2-smallHeaderBold'
            data-testid='success-info'
            options={{
              arg1: activeDecision,
            }}
            i18nKey={
              isDecisionMatch
                ? 'yourDecisionToSendAnSomeToThisCandidateHasBeenAdded'
                : isAdvanced
                ? 'yourDecisionToAdvanceTheCandidateHasBeenAdded'
                : 'yourDecisionToPassOnTheCandidateHasBeenAdded'
            }
          />
        </Grid>
      )}
    </CardWrapper>
  );
};

export default withTranslation()(DecisionConfirmation);
